import React from "react";
import Index from "../components/candidateSsoLogin";

export default function CandidateSsoLogin() {

  return (
    <>
      <Index />
    </>
  );
}
